module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_waso_studio_plus-00a12f2b061b6e52c871eed9d4d28970.jpg";